exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heroicon-document .heroicon-outline{fill:#303034}.heroicon-document .heroicon-component-fill{fill:#fff}.heroicon-document .heroicon-component-accent{fill:#919495}.heroicon-document .heroicon-shadows{fill:#303034;opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b1a1f4c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Icons/SubmissionIcon.vue
// module id = Y2Mw
// module chunks = 0